import { JssStyle } from 'css-jss';

export const sectionTitleStyle: JssStyle = {
  fontSize: '100%',
  fontWeight: 600,
  textTransform: 'uppercase',
  color: '#4b7faf',
};
